module.exports = __webpack_public_path__ + "static/media/youtube.91f9b219.svg";